module.exports = __webpack_public_path__ + "img/manage-loan.fd4a8e00.png";